// Window Scroll Handler

(function($) {

    $(window).on('scroll', function(){
        var scrollTop = $(window).scrollTop();
        // console.log('Scrolled distance from top: ' + scrollTop + ' pixels');

        // if (scrollTop > 125) {
        //     $(".header-utility").slideUp();
        // }
        // if (scrollTop < 25) {
        //     $(".header-utility").slideDown();
        // }
    })

}(jQuery));